module.exports = __webpack_public_path__ + "img/Malen.3a7329a7.jpg";